// extracted by mini-css-extract-plugin
export default {"v-application":"Search_v-application_Dk326","text-h1":"Search_text-h1_eSB7H","text-h2":"Search_text-h2_STWCJ","search":"Search_search_l0ZEX"};